<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('dw.report.customer.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-btn @click="exportReport" variant="success"><i class="fa fa-download mr-2"></i>{{$t('dw.general.export')}}</b-btn>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable keywordPlaceholder="Type to Search" searchAction="getCustomerReport" vuexModule="Dw" type="dw" :filters="filters" :columns="columns" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITSearchableTable, FITFormCard, FITButton } from '@/components'
import { domain } from '@/api/api.js'
import Vue from 'vue'
import { saveAs } from 'file-saver/FileSaver';
import { mapGetters } from 'vuex';
import moment from 'moment';
import download from 'downloadjs'


export default {
  name: 'reportCustomer',
  components: {
    FITSearchableTable,
    FITFormCard,
    FITButton
  },
  methods: {
    exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);
      console.debug(params);

      this.$store.dispatch('Dw/exportCustomerReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        var blob = new Blob([json.data]);
        saveAs(blob, fileName);

        // download(blob, '123.xls');
      })
    },
    convertEnglishName(type, item) {
      var englishName = Vue.options.filters.isEmpty(item[type + 'EnglishFirstname']);
      if (englishName !== 'N/A') {
        englishName = item[type + 'EnglishLastname'] + ' ' + englishName;
      }
      return englishName;
    },
    convertChineseName(type, item) {
      var chineseName = Vue.options.filters.isEmpty(item[type + 'ChineseFirstname']);
      if (chineseName !== 'N/A') {
        chineseName = item[type + 'ChineseLastname'] + chineseName;
      }
      return chineseName;
    }
  },
  computed: {
    monthOptions() {
      var months = [];
      for (var i = 0; i < 12; i++) {
        months.push({ text: moment().month(1).format('MMMM'), value: i + 1 })
      }
      return months;
    }
  },
  data() {
    return {
      currentFilters: {},
      exportLink: domain + '/report/customer?export=1',
      filters: [{
          label: this.$t('general.gender'),
          key: 'gender',
          type: 'select',
          default: null, // Default All
          options: [
            { text: this.$t('general.all'), value: null },
            { text: this.$t('general.M'), value: 'M' },
            { text: this.$t('general.F'), value: 'F' },
          ]
        },
        {
          label: this.$t('dw.report.customer.birthDayMonth'),
          key: 'birthDayMonth',
          type: 'select',
          default: null,
          options: [
            { text: this.$t('general.all'), value: null },
            { text: moment().month(0).format('MMMM'), value: 1 },
            { text: moment().month(1).format('MMMM'), value: 2 },
            { text: moment().month(2).format('MMMM'), value: 3 },
            { text: moment().month(3).format('MMMM'), value: 4 },
            { text: moment().month(4).format('MMMM'), value: 5 },
            { text: moment().month(5).format('MMMM'), value: 6 },
            { text: moment().month(6).format('MMMM'), value: 7 },
            { text: moment().month(7).format('MMMM'), value: 8 },
            { text: moment().month(8).format('MMMM'), value: 9 },
            { text: moment().month(9).format('MMMM'), value: 10 },
            { text: moment().month(10).format('MMMM'), value: 11 },
            { text: moment().month(11).format('MMMM'), value: 12 }
          ]
        },
        {
          label: this.$t('dw.report.customer.country'),
          key: 'country',
          type: 'select',
          optionsKey: 'nationality',
          default: null
        },
        {
          label: this.$t('dw.report.customer.nationality'),
          key: 'nationality',
          type: 'select',
          default: null
        },
        {
          label: this.$t('dw.report.applicationStartDate'),
          key: 'startDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('dw.report.applicationEndDate'),
          key: 'endDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('dw.report.customer.ageFrom'),
          key: 'ageLowerLimit',
          type: 'number',
          default: ''
        },
        {
          label: this.$t('dw.report.customer.ageTo'),
          key: 'ageUpperLimit',
          type: 'number',
          default: ''
        },
      ],
      columns: [{
          key: 'customerCode',
          label: this.$t('dw.report.customer.customerCode'),
          thClass: ['tableMinWidth120'],
          sortable: true,
        },
        {
          key: 'customerName',
          label: this.$t('dw.general.customerName'),
          tdClass: ['tableMinWidth150'],
          thClass: ['tableMinWidth150'],
          formatter: (row, key, item) => {
            return '<div>' + this.convertEnglishName('customer', item) + '</div>' +
              '<div>' + this.convertChineseName('customer', item) + '</div>'
          }
        },
        {
          key: 'gender',
          label: this.$t('dw.general.gender'),
          tdClass: ['text-center'],
          thClass: ['text-center'],
          sortable: true,
          formatter: (row, key, item) => {
            if (!row) { return "N/A"; }
            return this.$t('general.' + row);
          }
        },
        {
          key: 'dateOfBirth',
          label: this.$t('dw.general.dob'),
          sortable: true,
          formatter: (row, key, item) => {
            return Vue.options.filters.date(row);
          },
          tdClass: ['text-center'],
          thClass: ['text-center']
        },
        {
          key: 'nationalityEnglish',
          label: this.$t('dw.report.customer.nationality'),
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row) + '<br>' + Vue.options.filters.isEmpty(item.nationalityChinese)
          },
          tdClass: ['text-center'],
          thClass: ['text-center']
        },
        {
          key: 'agentName',
          label: this.$t('dw.general.agentName'),
          formatter: (row, key, item) => {
            return '<div>' + this.convertEnglishName('agent', item) + '</div>' +
              '<div>' + this.convertChineseName('agent', item) + '</div>'
          }
        },
        {
          key: 'generalPolicyCount',
          label: this.$t('dw.report.customer.generalPolicyCount'),
          tdClass: ['text-center'],
          thClass: ['text-center'],
          sortable: true,

        },
        {
          key: 'giPremium',
          label: this.$t('dw.report.customer.giPremium'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'lifePolicyCount',
          label: this.$t('dw.report.customer.lifePolicyCount'),
          tdClass: ['text-center'],
          thClass: ['text-center'],
          sortable: true,
        },
        {
          key: 'lifePremium',
          label: this.$t('dw.report.customer.lifePremium'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        }
      ],
      // autoSearchFilters: [{
      //   label: this.$t('dw.general.agent'),
      //   key: 'agentID',
      //   searchParams: {
      //     placeholder: ' Type to search',
      //     dest: 'option',
      //     paras: [{ key: 'type', value: 'agent' }],
      //     showItems: ['englishFullname', 'chineseFullname', 'agentCode']
      //   }
      // }],

    }
  }
}

</script>
<style type="text/css">
.tableMinWidth120 {
  max-width: 120px;
}

.tableMinWidth150 {
  max-width: 150px;
}

.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: default !important;
}

</style>



// WEBPACK FOOTER //
// src/Dw/containers/ReportCustomer.vue